<div class="screen">

    <!-- HEADER -->
    <div class="header">
      
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/technical-error.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Service not available</div>
  
      <div class="subtitle">
        Apologies for the issue. We're working on it now.
        Please try again.
      </div>
    </div>
  
    <!-- BUTTON -->
    <footer class="screen-footer">
      <button
        pButton
        label="TRY AGAIN"
        class="retry-btn"
        (click)="close()"
      ></button>  
    </footer>

    <!-- DEBUG & DIAGNOSTICS CARD -->
    <div class="debug-panel" *ngIf="isLocalhost || diagnostics">
      <div class="debug-header">
        <span class="debug-title">Session Debug Diagnostics</span>
        <span class="badge" [ngClass]="hasDiasporaSessionToken ? 'badge-success' : 'badge-danger'">
          {{ hasDiasporaSessionToken ? 'Token Obtained' : 'Token NOT Obtained' }}
        </span>
      </div>

      <div class="debug-body">
        <div class="debug-row">
          <span class="debug-label">diasporaSessionToken:</span>
          <span class="debug-value" [class.text-success]="hasDiasporaSessionToken" [class.text-danger]="!hasDiasporaSessionToken">
            {{ hasDiasporaSessionToken ? tokenPreview : 'None (Session token was NOT obtained)' }}
          </span>
        </div>

        <div class="debug-row" *ngIf="diagnostics?.stage">
          <span class="debug-label">Failure Stage:</span>
          <span class="debug-value font-mono">{{ diagnostics?.stage }}</span>
        </div>

        <div class="debug-row" *ngIf="diagnostics?.status !== undefined">
          <span class="debug-label">HTTP Status:</span>
          <span class="debug-value font-mono" [class.text-danger]="diagnostics?.status === 0 || (+diagnostics?.status! >= 400)">
            {{ diagnostics?.status }} {{ diagnostics?.statusText ? '(' + diagnostics?.statusText + ')' : '' }}
          </span>
        </div>

        <div class="debug-row" *ngIf="diagnostics?.url">
          <span class="debug-label">Endpoint URL:</span>
          <span class="debug-value font-mono font-xs">{{ diagnostics?.url }}</span>
        </div>

        <!-- Localhost CORS Alert -->
        <div class="alert-box alert-warning" *ngIf="isCorsBlocked">
          <strong>Localhost CORS Blocked:</strong> The backend APIM server rejected the cross-origin request from <code>http://localhost:4200</code>.
          <div class="alert-tip">
            <strong>Solution:</strong> Run Angular with the reverse proxy so requests go through the Node dev server:
            <pre class="code-snippet">npm run start:h5</pre>
            and launch in your browser with:
            <pre class="code-snippet">http://localhost:4200/?mobileAccessToken=YOUR_TOKEN</pre>
          </div>
        </div>

        <!-- General Diagnosis -->
        <div class="alert-box alert-info" *ngIf="diagnostics?.debugCause && !isCorsBlocked">
          <strong>Diagnosis:</strong> {{ diagnostics?.debugCause }}
        </div>

        <div class="alert-box alert-danger" *ngIf="diagnostics?.backendMessage">
          <strong>Backend Error:</strong> {{ diagnostics?.backendMessage }}
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="debug-actions">
        <button
          *ngIf="isLocalhost"
          pButton
          label="Launch with UAT Token"
          class="dev-bypass-btn"
          (click)="launchWithUatToken()"
          title="Launch the initiate journey with the verified UAT token"
        ></button>

        <button
          *ngIf="isLocalhost"
          pButton
          label="Proceed to /amount (Dev Bypass)"
          class="dev-secondary-btn"
          (click)="proceedWithDevToken()"
          title="Bypass initiate step with a mock token to test downstream screens"
        ></button>

        <button
          pButton
          [label]="showRawDiagnostics ? 'Hide JSON' : 'View Raw JSON'"
          class="dev-secondary-btn"
          (click)="toggleDiagnostics()"
        ></button>

        <button
          *ngIf="showRawDiagnostics"
          pButton
          [label]="copied ? 'Copied!' : 'Copy JSON'"
          class="dev-secondary-btn"
          (click)="copyDiagnostics()"
        ></button>
      </div>

      <pre class="raw-json" *ngIf="showRawDiagnostics">{{ diagnostics | json }}</pre>
    </div>
    
  </div>